import { createSelector } from '@ngrx/store';

import { selectLiveEdgeState } from './live-edge-base.selectors';

export const camerasViewState = createSelector(selectLiveEdgeState, state => state.cameraView);

export const getCameraTab = createSelector(camerasViewState, state => state.selectedTab);
